export default {"src":"/_next/static/media/mobile.48470890.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};